import { useAuth } from 'src/components/AuthProvider/AuthProvider';
import { useFeatureFlag } from 'src/hooks/useFeatureFlag';
import { FeatureFlag } from 'src/types/FeatureFlag';

export const useEmployeeListFeatureAccess = (): {
  canAccessEmployeeList: boolean;
  isLoading: boolean;
} => {
  const {
    enterpriseData: { isInternalAdminUser },
  } = useAuth();
  const { value: isEmployeeListEnabled, isLoading: isLoadingEmployeeList } =
    useFeatureFlag(FeatureFlag.ENABLE_NEW_EMPLOYEE_LIST_PAGE);
  const { value: isInternalOnlyPhase, isLoading: isLoadingInternalOnly } =
    useFeatureFlag(FeatureFlag.EMPLOYEE_LIST_INTERNAL_ONLY_PHASE);

  const canAccessEmployeeList =
    isEmployeeListEnabled && (!isInternalOnlyPhase || isInternalAdminUser);

  return {
    canAccessEmployeeList,
    isLoading: isLoadingEmployeeList || isLoadingInternalOnly,
  };
};
